var _a;
import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import { SVG } from '@at/design-system-elements';
import { ThemeSelectors } from '@at/design-system-foundation';
import { BulletIconColors } from './bullet-list.types';
export var BulletList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    list-style-type: none;\n    margin-top: ", ";\n    padding-left: ", ";\n\n    &.standard {\n        padding-left: 20px;\n\n        > li {\n            list-style-type: disc;\n            padding-left: ", ";\n        }\n    }\n"], ["\n    list-style-type: none;\n    margin-top: ", ";\n    padding-left: ", ";\n\n    &.standard {\n        padding-left: 20px;\n\n        > li {\n            list-style-type: disc;\n            padding-left: ", ";\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFiveSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
});
export var BulletListOrdered = styled.ol(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    list-style-type: none;\n    margin-top: ", ";\n    padding-left: 20px;\n\n    > li {\n        list-style-type: decimal;\n        padding-left: ", ";\n    }\n"], ["\n    list-style-type: none;\n    margin-top: ", ";\n    padding-left: 20px;\n\n    > li {\n        list-style-type: decimal;\n        padding-left: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
});
var fillSelectorRecord = (_a = {},
    _a[BulletIconColors.GREEN] = ThemeSelectors.getSuccessColor,
    _a[BulletIconColors.RED] = ThemeSelectors.getErrorColor,
    _a[BulletIconColors.WHITE] = ThemeSelectors.getWhite,
    _a[BulletIconColors.COPY] = ThemeSelectors.getCopyColor,
    _a[BulletIconColors.TITLE] = ThemeSelectors.getTitleColor,
    _a);
export var BulletListSVG = styled(SVG)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    left: calc(", " * -1);\n    position: absolute;\n    top: 3px;\n\n    ", "\n"], ["\n    left: calc(", " * -1);\n    position: absolute;\n    top: 3px;\n\n    ", "\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFiveSpacing(theme);
}, function (_a) {
    var theme = _a.theme, $fillColor = _a.$fillColor;
    if (!$fillColor)
        return;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            path {\n                fill: ", ";\n            }\n        "], ["\n            path {\n                fill: ", ";\n            }\n        "])), fillSelectorRecord[$fillColor](theme));
});
export var BulletListItem = styled.li(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: relative;\n    color: ", ";\n    margin-bottom: ", ";\n"], ["\n    position: relative;\n    color: ", ";\n    margin-bottom: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getTitleColor(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupTwoSpacing(theme);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
